import React, { useEffect, useState } from 'react';
import TController from './TController';
import { Box } from '@mui/material';
import { PersitedDatePicker } from '../../../../../../components/common';
import { useQuery } from '../../../../../../hooks/UseQuery';
import axios from 'axios';
import ParetoChart from './ParetoChart';
import BarChart from './BarChart';
import { GraphHead } from '../../../../../../components/common/GraphHeading';
interface IProps {
  apiData: any;
  top20?: any;
  allPart?: any;
  title1?:any;
  title2?:any;
}
const DefectWiseQty = ({ apiData, top20, allPart, title1 , title2}: IProps) => {
  return (
    <div>
      {!allPart && <TController apiData={apiData} top20={top20} />}
      {
        <>
          {!allPart && (
            <GraphHead style={{ width: '80vw', margin: '14rem' }}>
              <p>{title1}</p>
              <ParetoChart apiData={apiData} top20={top20} />
              </GraphHead>
          )}
            {(top20 || allPart) && (
              <GraphHead style={{ width: '80vw', margin: '14rem' }}>
                <p>{title2}</p>
              <BarChart apiData={apiData} allPart={allPart} />
              </GraphHead>
            )}
        </>
      }
    </div>
  );
};

export default DefectWiseQty;
